<div class="section" style="width: 800px; height: 650px; flex: 1; display: flex; flex-direction: column;" data-cy="case-final-report-select">
  <div class="section-header" data-cy="case-final-report-select-header">
    <div class="section-header-title" data-cy="case-final-report-select-title">Select Final Report Note</div>
  </div>
  <app-tdo-progress-spinner style="height: 100%;" *ngIf="isLoading" data-cy="case-final-report-select-spinner"></app-tdo-progress-spinner>
  <div class="section-content" style="display: flex; flex-direction: column; flex: 1;" *ngIf="!isLoading" data-cy="case-final-report-select-content">
    <div *ngIf="!isLoading" style="height: 535px;" data-cy="case-final-report-select-table-container">
      <div style="display:flex;" data-cy="case-final-report-select-layout">
        <div style="flex: 1" data-cy="case-final-report-select-list-container">
          <!--    list of final reports-->
          <div style="height: 535px;" data-cy="case-final-report-select-table-wrapper">
            <tdo-table [dataSource]="FinalReportNotes"
                       [isMultiSelection]="false" [isSearchable]="true" [isUsePaginator]="false"
                       [searchPredicate]="searchPredicate" (rowSelected)="onRowSelected($event)"
                       data-cy="case-final-report-select-table">
              <tdo-table-column displayName="Completed Date" propertyName="CompletedDate" isSortable="false" [rowTemplate]="cd" data-cy="case-final-report-select-column-date">
                <ng-template #cd let-row>
                  <div *ngIf="row.CompletedDate" data-cy="case-final-report-select-date">{{ row.CompletedDate | date }}</div>
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Note" propertyName="Note" isSortable="false" [rowTemplate]="n" data-cy="case-final-report-select-column-note">
                <ng-template #n let-row>
                  <div *ngIf="row.Note" data-cy="case-final-report-select-note">{{ row.Note }}</div>
                </ng-template>
              </tdo-table-column>
            </tdo-table>
          </div>
        </div>
      </div>
    </div>

<!--    <div class="action-container">-->
<!--      <button [disabled]="!this.SelectedFinalReport" class="tdo-button tdo-save" style="margin-right: 12px;" (click)="selectReport()">Select Report</button>-->
<!--      <button class="tdo-button tdo-close" style="margin-right: 12px;" (click)="cancel(false)">Close</button>-->
<!--    </div>-->

    <div class="section-footer" style="flex-basis: 60px; padding-top: 6px; text-align: right" data-cy="case-final-report-select-footer">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button [disabled]="!this.FinalReportNote" class="tdo-button tdo-save" style="margin-right: 12px;" (click)="selectReport()" data-cy="case-final-report-select-select-btn">Select Report Note</button>
      <button class="tdo-button tdo-close" style="margin-right: 12px;" (click)="cancel(false)" data-cy="case-final-report-select-close-btn">Close</button>
    </div>

  </div>
</div>
